import { DataObject } from '@shared/models/data-object.model';
import { ExecutableAction, ExecutableActionParam } from '../utils/executable-action';
import { CurrentDataModel } from './current-data.model';
export class UpdateDuplicateSpace implements ExecutableAction<CurrentDataModel> {
  static readonly type = '[Current Data] Update Duplicated Data';
  constructor(private updateObject: DataObject[]) {}
  execute(params: ExecutableActionParam<CurrentDataModel>): void {
    params.ctx.patchState({ duplicatedSpaces: this.updateObject });
  }
}
